import { faHome } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { ROUTES } from '../../constants/routes'
import { Breadcrumb, Breadcrumbs } from '../Breadcrumbs/Breadcrumbs'
import { TruncatedText } from '../TruncatedText/TruncatedText'

interface IProps {
  title?: React.ReactElement | string
  subtitle?: React.ReactElement | string
  primaryAction?: React.ReactElement
  breadcrumbs?: Breadcrumb[]
}

export const Header = (props: IProps): React.ReactElement => (
  <div className="header mt-5">
    <div className="header-body">
      <h6 className="text-uppercase text-body-secondary fw-normal">{props.subtitle}</h6>
      <h1 className="row">
        <TruncatedText className="col">
          <span>{props.title}</span>
        </TruncatedText>
        {props.primaryAction ? (
          <div className="d-lg-inline h5 text-body-secondary my-auto col-auto">
            {props.primaryAction}
          </div>
        ) : null}
      </h1>
      <Breadcrumbs
        items={[
          { to: ROUTES.DASHBOARD, label: <FontAwesomeIcon icon={faHome} /> },
          ...(props.breadcrumbs || []),
        ]}
      />
    </div>
  </div>
)
